import home1 from "../../assets/img/widget.png";
import landImg from "../../assets/img/landscaping.webp";
import { Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
const ourService = [
  { id: 1, name: "Landscape Design", url: "landscape-design" },
  { id: 2, name: "Hardscape", url: "hardscape" },
  { id: 3, name: "Landscape Lighting", url: "landscape-lighting" },
  { id: 4, name: "Softscape", url: "softscape" },
  { id: 5, name: "Plantation", url: "plantation" },
  { id: 6, name: "Replanting", url: "replanting" },
  {
    id: 7,
    name: "Lawn Development and Maintenance",
    url: "lawn-development-and-maintenance",
  },
  {
    id: 8,
    name: "Horticultural Maintenance",
    url: "horticultural-maintenance",
  },
  {
    id: 9,
    name: "Vertical & Terrace Garden",
    url: "vertical-and-terrace-garden",
  },
  { id: 10, name: "Irrigation System", url: "irrigation-system" },
];
function Replanting() {
  return (
    <>
      <section className="serviceList sectionPD">
        <div class="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="aboutImg">
                <img src={home1} alt="About" className="img-fluid" />
              </div>
              <div className="blogCategory mt-4">
                <ul>
                  {ourService.map((item) => {
                    return (
                      <li key={item.id}>
                        <Link to={`${item.url}`}>
                          <FiChevronRight />
                          {item.name}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="fisherman-content">
                <h6>Giving New Life to Existing Landscapes</h6>
                <h3>🌱 Replanting</h3>
                <p>
                  Replanting is more than just moving plants from one place to
                  another — it’s about giving them a second chance to grow,
                  thrive, and bring life to a space. Often, gardens or
                  landscapes need rejuvenation, and replanting is a key step in
                  keeping them healthy, vibrant, and sustainable.
                </p>
                <p>
                  A successful replanting process begins with understanding the
                  plant’s needs — its root system, soil type, sunlight, and
                  water requirements. Careful handling ensures the plant adapts
                  well to its new location, minimizing stress and encouraging
                  strong growth.
                </p>
                <p>
                  Replanting is also an opportunity to improve the overall
                  design of a space. By repositioning plants thoughtfully, you
                  can enhance aesthetics, allow better airflow, improve sunlight
                  distribution, and create a balanced environment where every
                  plant can flourish.
                </p>
                <p>
                  Authentic replanting is patient work. It requires nurturing,
                  attention, and timing — knowing the right season, preparing
                  the soil, and supporting the plant during the transition. Done
                  well, replanting doesn’t just save plants; it transforms
                  spaces and helps landscapes stay lively year after year.
                </p>
                <p>
                  In the end, replanting is a gentle reminder that growth can
                  continue, even after change. With care and planning, it
                  breathes new life into a garden, making it stronger,
                  healthier, and more beautiful than before.
                </p>
              </div>
              <div className="fisherman-content">
                <h5>🌱 Breathe New Life Into Your Garden</h5>
                <p>
                  Replanting gives your landscape a second chance — or even a
                  fresh start. Whether you're reviving a tired lawn or
                  redesigning a garden corner, our team will help you reimagine
                  your space with expert care and sustainable planting choices.
                </p>
                <a className="commonButton mt-3" href="mailto:info@example.com">
                  📧 Contact Us Today
                </a>
              </div>
            </div>
          </div>

          <div className="fisherman-content d-none">
            <h4>🛠️ Our Replanting Services Include:</h4>
            <ul>
              <li>On-site plant health and soil evaluation</li>
              <li>Removal of dead or poorly placed plants</li>
              <li>Selection of suitable replacements</li>
              <li>Transplanting healthy existing plants to new locations</li>
              <li>Soil improvement and mulching</li>
              <li>Seasonal flower bed replanting</li>
              <li>Ongoing maintenance and monitoring</li>
            </ul>
          </div>
          <div className="fisherman-content d-none">
            <h4>🌿 Why Replanting Is Important</h4>
            <ul>
              <li>
                <strong>Refreshes Overgrown or Unhealthy Areas</strong>
              </li>
              <li>
                <strong>Improves Plant Placement for Sun, Soil & Space</strong>
              </li>
              <li>
                <strong>Allows Seasonal or Thematic Updates</strong>
              </li>
              <li>
                <strong>Revives Soil Health and Garden Aesthetics</strong>
              </li>
              <li>
                <strong>
                  Corrects Initial Design Mistakes or Spacing Issues
                </strong>
              </li>
              <li>
                <strong>Enables Sustainable Plant Choices</strong>
              </li>
            </ul>
          </div>
          <div className="fisherman-content d-none">
            <h4>🔄 When to Consider Replanting</h4>
            <ul>
              <li>Plants are no longer thriving in their current location</li>
              <li>You want to introduce new species or seasonal colors</li>
              <li>Your trees or shrubs are crowding each other</li>
              <li>Soil quality has declined or needs amending</li>
              <li>You’re updating your landscape design or layout</li>
              <li>After pest damage or disease outbreak</li>
              <li>
                For eco-friendly upgrades with native or drought-tolerant plants
              </li>
            </ul>
          </div>
          <div className="fisherman-content d-none">
            <h4>🧠 Replanting Best Practices</h4>
            <ul>
              <li>Test and amend the soil before planting</li>
              <li>Choose healthy, region-appropriate plants</li>
              <li>Use proper spacing and consider mature plant size</li>
              <li>Water deeply and consistently after replanting</li>
              <li>Use mulch to retain moisture and reduce weed growth</li>
              <li>Plan for seasonal transitions and long-term growth</li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}

export default Replanting;
